
import filters from "~/mixins/filters";
// import { mapActions, mapMutations } from "vuex";

export default {
  mixins: [filters],
  computed: {
    currentCategory() {
      // category_enum убран из запроса (error500 в API) — категория из адреса страницы
      return this.offer.category_enum || this.$route.params.category || 'cars';
    },
    currentMark() {
      return this.offer.mark.slug;
    },
    currentFolder() {
      return this.offer.folder.slug;
    },
    currentId() {
      return this.offer.external_id;
    },
  },
  props: {
    isForm: {
      type: Boolean,
      default: false,
    },
    url: String,
    small: {
      type: Boolean,
      default: false,
    },
    offer: {
      type: Object,
      default: () => {},
    },
  },
};
